<template>
  <v-row align="center">
    <AppTooltip
      v-if="file.status === 'error'"
      location="bottom"
      max-width="400"
    >
      <template #activator="{ props }">
        <span v-bind="props">
          <app-material-icon name="close" />
        </span>
      </template>
      <span>{{ $t('common.msgFailErrorOccurred') }}</span>
    </AppTooltip>
    <template v-else>
      <app-material-icon
        v-if="!validator['$invalid']"
        name="check_circle"
        color="icon-success"
        filled
      />

      <AppTooltip
        v-if="validator['$error']"
        location="bottom"
        max-width="400"
      >
        <template #activator="{ props }">
          <span v-bind="props">
            <app-material-icon name="warning" color="icon-warning" filled />
          </span>
        </template>
        <span>{{ $t('common.validations.fillOutAll') }}</span>
      </AppTooltip>
    </template>

    <ClosdFildersIcon class="mr-4" :document="file"/>

    <span class="heading-xs-bold d-flex flex-column py-1 flex-grow-1 text-text-secondary" data-locator="file-name">
      {{ file.templateName ?? file.name }}
      <SigningChecklistDocumentWarning :file="file"/>
    </span>

    <AppButton
      v-if="file.status === 'error'"
      type="icon"
      @click.prevent.stop="onDeleteFile"
    >
      <app-material-icon name="close" />
    </AppButton>
    <v-col class="text-right mr-3 text-no-wrap">
      <span class="detail-md-regular text-text-tertiary">
        {{ $t('project.signing-checklist.add.SigningChecklistSectionDocumentHeader.stepHint') }}
      </span>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import AppTooltip from '@/common/AppTooltip.vue'
import ClosdFildersIcon from '@/common/filders/ClosdFildersIcon.vue'
import AppButton from '@/design-system/buttons/AppButton.vue'
import SigningChecklistDocumentWarning from '@/project/signing-checklist/SigningChecklistDocumentWarning.vue'
import { SigningChecklistFile } from '@/project/views/SigningChecklistAdd.vue'

export default defineComponent({
  name: 'SigningChecklistDocumentHeader',
  components: {
    AppButton,
    AppTooltip,
    ClosdFildersIcon,
    SigningChecklistDocumentWarning,
  },
  emits: ['delete-file'],
  props: {
    file: {
      type: Object as PropType<SigningChecklistFile>,
      required: true,
    },
    validator: {
      type: Object,
      required: true,
    },
  },
  methods: {
    onDeleteFile () {
      this.$emit('delete-file')
    },
  },
})
</script>

<style scoped lang="scss">
</style>
